/**
 * Standard orientation values
 */
export const Orientation = {
    horizontal: "horizontal",
    vertical: "vertical",
};
